module.exports = __webpack_public_path__ + "assets/img/20_49_big.554ad4f1.jpg";